import { Box, Flex, Text, UnderlineButton } from "flicket-ui";
import { CompetitionFragmentFragment } from "~graphql/sdk";
import { formatEventDate } from "~lib/helpers/formatDate";

interface CompetitionCardFooterProps {
  competition: CompetitionFragmentFragment;
  timezone: string;
  locale: string;
}

export default function CompetitionCardFooter(
  props: CompetitionCardFooterProps
) {
  const endDateFormatted = formatEventDate(
    props.competition?.endDate,
    "datetime",
    {
      timeZone: props.timezone,
      locale: props.locale,
    }
  );

  const competitionClosesText = `Competition closes ${endDateFormatted}`;

  return (
    <Flex flexDirection={"column"} style={{ gap: "12px" }}>
      <Text
        color="N700"
        fontWeight={"regular"}
        fontSize={2}
        textAlign={"center"}
      >
        {competitionClosesText}
      </Text>
      <Box textAlign={"center"}>
        <UnderlineButton
          href="#competition-details"
          color="N800"
          fontSize={3}
          fontWeight={"regular"}
        >
          More info
        </UnderlineButton>
      </Box>
    </Flex>
  );
}
